import {
  ISmartyStreetsPrecision,
  CountryISO2,
  ISO2CodeToNamesMap,
} from "../types";

/**
 * Determines if a validated address precision value is a pass.
 * A pass is when precision is one of: ["Manual", "DeliveryPoint", "Premise"].
 * @param precision validated address precision
 * @deprecated
 */
export const isValidationPass = (
  precision: ISmartyStreetsPrecision
): boolean => {
  const passingPrecision: ISmartyStreetsPrecision[] = [
    ISmartyStreetsPrecision.MANUAL,
    ISmartyStreetsPrecision.PREMISE,
    ISmartyStreetsPrecision.DELIVERY_POINT,
  ];

  return passingPrecision.includes(precision);
};

/**
 * Determines if a given validated address precision value is a pass.
 * A pass is when precision is one of: ["Manual", "DeliveryPoint", "Premise"].
 * @param precision validated address precision
 */
export const isAddressValidationPrecise = (
  precision: ISmartyStreetsPrecision
): boolean => {
  const passingAddressPrecision: ISmartyStreetsPrecision[] = [
    ISmartyStreetsPrecision.MANUAL,
    ISmartyStreetsPrecision.PREMISE,
    ISmartyStreetsPrecision.DELIVERY_POINT,
  ];

  return passingAddressPrecision.includes(precision);
};

/**
 * Determines if a validated address geocode precision value is a pass.
 * A pass is when precision is one of: ["Manual", "Throughfare", "DeliveryPoint", "Premise"].
 * @param precision validated address geocode precision
 */
export const isGeocodeValidationPrecise = (
  precision: ISmartyStreetsPrecision
): boolean => {
  const passingGeocodePrecision: ISmartyStreetsPrecision[] = [
    ISmartyStreetsPrecision.MANUAL,
    ISmartyStreetsPrecision.THOROUGHFARE,
    ISmartyStreetsPrecision.PREMISE,
    ISmartyStreetsPrecision.DELIVERY_POINT,
  ];

  return passingGeocodePrecision.includes(precision);
};

/**
 * Determines if a validated address precision is good enough for our system.
 * @param addressPrecision validated address precision
 * @param geocodePrecision validated address geocode precision
 */
export const isValidationPrecisionPass = (
  addressPrecision: ISmartyStreetsPrecision = ISmartyStreetsPrecision.NONE,
  geocodePrecision: ISmartyStreetsPrecision = ISmartyStreetsPrecision.NONE
): boolean => {
  return (
    isAddressValidationPrecise(addressPrecision) ||
    isGeocodeValidationPrecise(geocodePrecision)
  );
};

/**
 * Converts given country name (case-insensitive) to ISO2 format. Supports multiple
 * formats for country names, for ex. Canada, CAN, ca => CA.
 * @param countryName case insensitive country name
 */
export const countryNameToISO2 = (countryName: string): CountryISO2 | null => {
  const normalizedCountryName = countryName?.trim().toLowerCase();
  const countryCodes = Object.values(CountryISO2);

  for (const countryCode of countryCodes) {
    if (ISO2CodeToNamesMap[countryCode].has(normalizedCountryName)) {
      return countryCode;
    }
  }

  return null;
};
